import React from 'react'

export interface WallboxLabelContextValue {
  wallboxLabelMap: Record<string, string>
}

export const WallboxLabelContext = React.createContext<WallboxLabelContextValue>({
  wallboxLabelMap: {},
})
